import { type FC } from "react";

const ExternalRedirect: FC = () => {
    window.location.href = "https://myhomeisyours.com";
    
    return <></>;
}

export default ExternalRedirect;